export default __webpack_public_path__ + "static/media/Logo-White.664b1288.png";